export const NEWS = {
  NEWS_FALLBACK_IMAGE: "https://imagecache.365scores.com/image/upload/f_jpg,w_240,h_132,c_limit,q_auto:eco,dpr_1/v1/WebSite/AssetsSVGNewBrand/Social_share_image",

  ACTION_TYPES: {
    displayHandler: 'displayHandler',
    onArticleDisplay: 'onArticleDisplay',
    onArticleClick: 'onArticleClick',
    onSeeAllClick: 'onSeeAllClick'
  },

  IMAGE_SIZE: {
    default: {
      width: 300,
      height: 168
    },
    preview: {
      width: 240,
      height: 132
    },
    small_view: {
      width: 360,
      height: 200
    },
    small_view_preview: {
      width: 180,
      height: 100
    }
  },

  URLS_CONFIG:{
    PARAM: {
      screen: "$SCREEN",
      context: "$CONTEXT",
    },
    VALUE: {
      screen: "webNews",
      context: "link",
    }
  }
}
